/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import politicalCampaignCrumbs from './political-campaign-crumbs';
import {PoliticalCampaignResource} from '../../components/api/resources/resource/political-campaign.resource';

export function politicalCampaignStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const blockDeleteResolve = function(): string | null {
    const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

    return LocalUserPermissions.canEditPoliticalResources()
      ? null
      : 'You do not have permission to update political campaigns.';
  };

  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper(
          'political-campaigns.political-campaign',
          PoliticalCampaignResource,
          'app.pol',
          'app'
        );
    
        $stateProvider.state(rh.listPath(), rh.list({
          data: {
            app: 'POLITICAL'
          },
          views: {
            'content@app': { component: getRoutePageComponent('political-campaign-route') }
          }
        }));
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'PoliticalCampaign',
          crumbParams: politicalCampaignCrumbs,
          editTag: 'adn-political-campaign-edit-page',
          itemData: {
            app: 'POLITICAL'
          },
          itemResolve: {
            blockDelete: blockDeleteResolve
          }
        });
  }, adnRouterHelper);
}
